export const common = {
  nav: {
    about: 'About',
    services: 'Services',
    partnership: 'Partnership',
    network: 'Global Network',
    contact: 'Contact Us',
  },
  hero: {
    badge: 'Korea ↔ Sri Lanka ↔ South & West Asia · Middle East',
    title1: 'Connecting Korea with South & West Asia and the Middle East',
    title2: 'Global Distribution Network',
    subtitle: 'Supplying Korean products to South & West Asia and the Middle East through Sri Lanka, and expanding global markets with premium Golden Coco brand',
    cta1: 'Business Proposal',
    cta2: 'Learn About Golden Coco',
    stat1: {
      number: '530+',
      title: 'Cagil mart Stores',
      subtitle: 'Across Sri Lanka',
    },
    stat2: {
      number: 'Golden Coco',
      title: 'Premium Brand',
      subtitle: 'Global Export',
    },
    stat3: {
      number: 'Unmanned Stores',
      title: 'Smart Retail',
      subtitle: 'Domestic Operations',
    },
  },
  services: {
    badge: 'Our Business',
    title: 'Core Business Areas',
    subtitle: 'From global distribution network connecting Korea and Sri Lanka to premium brand operations',
    items: [
      {
        title: 'Korean Product Export',
        description: 'We supply Korean industrial and food products to South & West Asia and the Middle East through Sri Lanka. We have a stable distribution network through 530+ Cagil mart stores and local subsidiary Global one.',
      },
      {
        title: 'Golden Coco Brand',
        description: 'We supply premium Sri Lankan coco peat and coco chips worldwide under the Golden Coco brand. Recognized in global markets as eco-friendly materials.',
      },
      {
        title: 'Unmanned Store Operations',
        description: 'We operate smart unmanned stores domestically, providing innovative retail solutions. 24-hour operations maximize customer convenience.',
      },
      {
        title: 'Local Subsidiary Operations',
        description: 'Through our Sri Lankan local subsidiary Global one, we build a stable supply chain for entering South & West Asian and Middle Eastern markets, developing business based on deep understanding of local markets.',
      },
      {
        title: 'Logistics Network',
        description: 'We realize fast and safe product supply with an efficient logistics system connecting from Korea through Sri Lanka to South & West Asia and the Middle East.',
      },
      {
        title: 'Partnership Building',
        description: 'We create a mutually growing business ecosystem through close cooperation with global distribution partners in South & West Asia and the Middle East.',
      },
    ],
  },
  partnership: {
    badge: 'Partnership & Brand',
    title: 'Partnership & Brand',
    subtitle: 'Leading the global market with global distribution partners and our own brand',
    items: [
      {
        name: 'Cagil mart',
        country: 'Sri Lanka',
        description: 'A key partnership supplying Korean industrial and food products to South & West Asia and the Middle East through 530+ Cagil mart stores, Sri Lanka\'s largest distribution network. We have built a stable distribution network through local subsidiary Global one.',
      },
      {
        name: 'Golden Coco',
        country: 'Global',
        description: 'Our own brand supplying premium Sri Lankan coco peat and coco chips worldwide. Highly rated in European, North American, and Asian markets as eco-friendly materials.',
      },
      {
        name: 'Global one',
        country: 'Sri Lanka',
        description: 'Our Sri Lankan local subsidiary serving as a key hub for distribution in South & West Asia and the Middle East',
      },
      {
        name: 'Domestic Unmanned Stores',
        country: 'South Korea',
        description: 'We operate unmanned stores domestically using smart technology, providing 24-hour convenience and efficient operating systems.',
      },
      {
        name: 'Korean Manufacturer Partners',
        country: 'South Korea',
        description: 'We partner with excellent Korean industrial and food manufacturers to support their entry into South & West Asian and Middle Eastern markets through Sri Lanka.',
      },
      {
        name: 'South & West Asia · Middle East Buyers',
        country: 'Global',
        description: 'We trade with buyers in South & West Asia and the Middle East based in Sri Lanka, expanding global markets through the Golden Coco brand.',
      },
    ],
  },
  cta: {
    title1: 'Connecting Korea with South & West Asia and the Middle East',
    title2: 'Global Business Partner',
    subtitle: 'From the supply chain of 530+ Cagil mart stores in Sri Lanka to South & West Asian and Middle Eastern markets, grow with INSIDE Global',
    button1: 'Business Proposal',
    button2: 'Golden Coco Inquiry',
  },
  footer: {
    tagline: 'Global Partner for Korean Companies',
    about: {
      title: 'About',
      overview: 'Company Overview',
      management: 'Management',
      history: 'History',
      careers: 'Careers',
    },
    services: {
      title: 'Services',
      research: 'Market Research',
      matching: 'Partner Matching',
      legal: 'Legal Consulting',
      marketing: 'Marketing Strategy',
    },
    partnership: {
      title: 'Partnership',
      cases: 'Success Stories',
      network: 'Partner Network',
      inquiry: 'Partnership Inquiry',
      benefits: 'Partner Benefits',
    },
    support: {
      title: 'Support',
      faq: 'FAQ',
      contact: 'Contact',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
    newsletter: {
      title: 'Creating new standards\nfor global business',
      subtitle: 'Get the latest global\nbusiness news',
      placeholder: 'Email address',
    },
    copyright: '© INSIDE Global 2025. All rights reserved.',
    poweredBy: 'for the world better place by inside global',
  },
};
